module.exports = __webpack_public_path__ + "64aa55cb.png";